class GoondiHeroSlider {
  constructor(el) {
    this.el       = el;
    this.track    = el.querySelector('.ghs-track');
    this.slides   = [...el.querySelectorAll('.ghs-slide')];
    this.dots     = [...el.querySelectorAll('.ghs-dot')];
    this.progress = el.querySelector('.ghs-progress');
    this.total    = this.slides.length;
    this.current  = 0;
    this.delay    = parseInt(el.dataset.speed || '5000', 10);
    this.autoplay = el.dataset.autoplay !== 'false';
    this.timer    = null;

    el.querySelector('.ghs-arrow--prev')?.addEventListener('click', () => this.prev());
    el.querySelector('.ghs-arrow--next')?.addEventListener('click', () => this.next());

    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

    // Pause on hover
    el.addEventListener('mouseenter', () => this.pause());
    el.addEventListener('mouseleave', () => { if (this.autoplay) this.start(); });

    // Touch swipe
    let startX = 0;
    el.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) diff > 0 ? this.next() : this.prev();
    }, { passive: true });

    this.goTo(0, false);
    if (this.autoplay && this.total > 1) this.start();
  }

  goTo(index, animate = true) {
    this.current = (index + this.total) % this.total;
    this.track.style.transition = animate ? 'transform 0.55s cubic-bezier(0.4,0,0.2,1)' : 'none';
    this.track.style.transform  = `translateX(-${this.current * 100}%)`;
    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
    if (this.autoplay && this.total > 1) this.resetProgress();
  }

  next() { this.pause(); this.goTo(this.current + 1); if (this.autoplay) this.start(); }
  prev() { this.pause(); this.goTo(this.current - 1); if (this.autoplay) this.start(); }

  start() {
    this.pause();
    this.resetProgress();
    this.timer = setTimeout(() => { this.goTo(this.current + 1); this.start(); }, this.delay);
  }

  pause() {
    clearTimeout(this.timer);
    if (this.progress) {
      this.progress.classList.remove('is-running');
      this.progress.style.width = '0%';
    }
  }

  resetProgress() {
    if (!this.progress) return;
    this.progress.classList.remove('is-running');
    this.progress.style.transition = 'none';
    this.progress.style.width      = '0%';
    // Force reflow
    void this.progress.offsetWidth;
    this.progress.style.transition = `width ${this.delay}ms linear`;
    this.progress.classList.add('is-running');
    this.progress.style.width      = '100%';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ghs-section').forEach(el => new GoondiHeroSlider(el));
});
